import { css } from 'linaria';

export const selectLink = css`
  text-decoration: none;
`;
